/**
 * Best-effort display name for the impersonated user (banner, dialogs).
 * Prefers the loaded employee in the current company, then target user fields.
 */
export function getImpersonationTargetLabel(auth) {
  const targetUser = auth?.impersonation?.targetUser;
  const employee = auth?.employee;

  const fromEmployee =
    employee?.name || [employee?.firstName, employee?.surName].filter(Boolean).join(' ').trim();
  if (fromEmployee) {
    return fromEmployee;
  }

  if (!targetUser) {
    return '';
  }

  if (targetUser.name) {
    return targetUser.name;
  }

  const fromUser = [targetUser.firstName, targetUser.surName].filter(Boolean).join(' ').trim();
  if (fromUser) {
    return fromUser;
  }

  const companyId = auth?.company_id;
  const companyMatch = targetUser.companies?.find(c => c._id === companyId);
  const fromCompanyEmployee = companyMatch?.employee
    ? [companyMatch.employee.firstName, companyMatch.employee.surName]
        .filter(Boolean)
        .join(' ')
        .trim()
    : '';
  if (fromCompanyEmployee) {
    return fromCompanyEmployee;
  }

  for (const company of targetUser.companies || []) {
    const empName = [company.employee?.firstName, company.employee?.surName]
      .filter(Boolean)
      .join(' ')
      .trim();
    if (empName) {
      return empName;
    }
  }

  if (targetUser.email) {
    return targetUser.email;
  }
  if (targetUser.phone) {
    return targetUser.phone;
  }

  return targetUser._id || '';
}
